<template>
  <div id="pcCommunity" class="swiper-container community-swiper">
    <div class="swiper-wrapper">
      <div class="swiper-slide page page1">
        <div class="title t1 dh">
          <span class="text dh">{{$t('message.strid14')}}</span>
          <span class="text2 dh">{{$t('message.strid14')}}</span>
        </div>
        <div class="people-wrap">
          <div @click="bigImg(i)" v-lazy:background-image="{src: i}" :class="`people${index + 1}`" v-for="(i, index) in list" :key="index"></div>
          <div @click="jumpMore()" class="people22">{{$t('message.strid8')}}</div>
        </div>
        <div v-if="img" class="mask" @click="closeMask">
          <div class="img-wrap">
            <img class="close" src="@/assets/images/close.png" alt="">
            <img class="img" v-lazy="img" alt="">
          </div>
        </div>
      </div>
      <div class="swiper-slide page page2">
        <div class="title t2" :class="dh ? 'dh' : ''">
          <span class="text" :class="dh ? 'dh' : ''">{{$t('message.strid15')}}</span>
          <span class="text2" :class="dh ? 'dh' : ''">{{$t('message.strid15')}}</span>
        </div>
        <div class="kol-wrap">
          <img class="prev" @click="moveKol(1)" src="@/assets/images/prev.png" alt="">
          <img class="next" @click="moveKol(2)" src="@/assets/images/next.png" alt="">
          <div class="swiper-container kol-swiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(i, index) in kolList" :key="index">
                <div class="box"  v-lazy:background-image="{src: i.cover}">
                  <img @click="play(i.url)" src="@/assets/images/play.png" alt="" class="play">
                  <div class="info">{{i.title}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a :href="more" target="_blank" class="more-kol">{{$t('message.strid8')}}</a>
        <div v-if="ytsrc" @click="closeMask" class="mask">
          <img src="@/assets/images/close.png" class="close2" alt="">
          <iframe id="youtube" :src="ytsrc" frameborder="0" allowfullscreen=""></iframe>
        </div>
      </div>
      <div class="swiper-slide bottom">
        <div class="creater">
          <a target="_blank" :class="$i18n.locale" href="https://creatorcamp.mobilelegends.com/#/" class="creater-btn">{{$t('message.strid16')}}</a>
        </div>
        <Footer></Footer>
      </div>
    </div>
  </div>
</template>

<script>
import Footer from "@/components/bottom"
import { getKol } from "@/proxy/index"
import { mapState } from "vuex";
export default {
  components: {
    Footer
  },
  computed: {
    ...mapState(["_myData"]),
  },
  watch: {
    '_myData': {
      handler (n, o) {
        if (n) {
          const data = n.community
          data.fan_works.data.map(i => {
            this.list.push(i.img + '&imageslim')
          })
          this.picmore = data.fan_works.more
          this.more = data.kol.more
          this.getVideo(data.kol.channel_id, data.kol.num)
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      mySwiper: null,
      mySwiper2: null,
      dh: false,
      list: [],
      img: '',
      kolList: [],
      ytsrc: '',
      more: '',
      picmore: ''
    }
  },
  mounted () {
    const that = this
    this.mySwiper = new Swiper(".community-swiper", {
      direction : 'vertical',
      slidesPerView: 'auto',
      mousewheel: true,
      on: {
        transitionStart () {
          that.closeMask()
          switch (this.activeIndex) {
            case 1:
              that.dh = true
              break;
          }
        }
      }
    });

    this.mySwiper2 = new Swiper('.kol-swiper', {
      observer:true,
      nested:true,
      slidesPerView: 'auto',
      normalizeSlideIndex:false,
    })

    // setTimeout(() => {
    //   for (let i = 0; i < 21; i++) {
    //     this.list.push('//akmwebstatic.yuanzhanapp.com/web/madmin/image_f22fa3ec8a2c08281c8e292afea494b0?w=811&h=811&c=4d4441&imageslim')
    //   }
    //   this.kolList = [
    //     {
    //       title: 'These 2 Hyper Heroes Carries the Game Too Easilysfsfsdf s fsd fdsf s ff ',
    //       cover: 'https://i.ytimg.com/vi/1WolDM3mnSY/mqdefault.jpg',
    //       url: 'https://www.youtube.com/embed/iYzXNYTANc8'
    //     },
    //     {
    //       title: 'These 2 Hyper Heroes Carries the Game Too Easilysfsfsdf s fsd fdsf s ff ',
    //       cover: 'https://i.ytimg.com/vi/1WolDM3mnSY/mqdefault.jpg',
    //       url: 'https://www.youtube.com/embed/iYzXNYTANc8'
    //     },
    //     {
    //       title: 'These 2 Hyper Heroes Carries the Game Too Easilysfsfsdf s fsd fdsf s ff ',
    //       cover: 'https://i.ytimg.com/vi/1WolDM3mnSY/mqdefault.jpg',
    //       url: 'https://www.youtube.com/embed/iYzXNYTANc8'
    //     }
    //   ]
    // }, 1000)
  },
  methods: {
    bigImg (src) {
      this.img = src
      this.$store.dispatch('setShow', false)
    },
    play (url) {
      this.ytsrc = url
      this.$store.dispatch('setShow', false)
    },
    closeMask () {
      this.img = ''
      this.ytsrc = ''
      this.$store.dispatch('setShow', true)
    },
    moveKol (index) {
      if (index == 1) {
        this.mySwiper2.slidePrev()
      } else {
        this.mySwiper2.slideNext()
      }
    },
    jumpMore () {
      window.open(this.picmore)
    },
    getVideo (id, size) {
      getKol({
        channel_id: id,
        producer_id: 0,
        lang: this.$i18n.locale,
        page: 1,
        page_size: size,
        sort: 1
      }).then(res => {
        if (res.code == 0) {
          res.data.list.map(i => {
            this.kolList.push({
              title: i.title,
              cover: i.thumbnail,
              url: `https://www.youtube.com/embed/${i.key}`
            })
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/style/community.scss";
</style>